import styled from "styled-components";
import { BiShow, BiHide } from "react-icons/bi";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.white0};

  width: 100%;
  height: 100vh;
`;

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  min-width: 470px;
  width: 23%;
  height: 60%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
`;

export const LogoContainer = styled.div`
  width: 70%;
  height: 120px;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 65%;
  gap: 20px;
  margin-top: 40px;
  margin-bottom: 20px;
`;

export const PasswordContainer = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  height: 48px;
  position: relative;
`;

export const Input = styled.input`
  background-color: ${(props) => props.theme.white2};
  border: 1px solid ${(props) => props.theme.white2};
  border-radius: 20px;
  width: 100%;
  height: 48px;
  padding: 0 10px;
  color: unset;
  &:focus {
    outline: none;
  }
`;

export const ShowIcon = styled(BiShow)`
  font-size: 16px;
  color: ${(props) => props.theme.black2};
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

export const HiddenIcon = styled(BiHide)`
  font-size: 16px;
  color: ${(props) => props.theme.black2};
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

export const SelectBox = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.white2};
  border: 1px solid ${(props) => props.theme.white2};
  border-bottom: ${(props) => props.$isSelectBoxOpen && "none"};
  border-radius: ${(props) =>
    props.$isSelectBoxOpen ? "20px 20px 0 0" : "20px"};
  width: 100%;
  height: 48px;
  padding: 0 10px;
  font-size: 14px;
  color: ${(props) => props.theme.black2};
  cursor: pointer;
  z-index: 5;

  &:focus {
    outline: none;
  }
`;

export const ArrowDown = styled(IoIosArrowDown)`
  width: 15px;
  height: 15px;
`;

export const ArrowUp = styled(IoIosArrowUp)`
  width: 15px;
  height: 15px;
`;

export const OptionContainer = styled.div`
  position: absolute;
  top: 48px;
  left: -1px;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.white2};
  border: 1px solid ${(props) => props.theme.white2};
  border-top: ${(props) => props.$isSelectBoxOpen && "none"};
  border-radius: 0 0 20px 20px;

  padding: 10px 0;
  width: calc(100% + 2px);
  gap: 5px;
`;

export const Option = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  padding: 3px 10px;
  font-size: 14px;
  color: ${(props) => props.theme.black2};
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.white3};
    font-weight: 500;
  }
`;

export const SaveContainer = styled.div`
  display: flex;
  align-items: center;

  width: 64%;
  height: 20px;
  gap: 3px;
  color: ${(props) => props.theme.black2};
  font-size: 16px;
`;

export const CheckBox = styled.input`
margin-left: 10px;
`;

export const LoginButtonContainer = styled.div`
  width: 70%;
  height: 48px;
  margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  button {
    font-size: 14px;
    font-weight: 600;
    background-color: ${(props) => props.theme.blue1};
    color: ${(props) => props.theme.white0};
    padding: 5px 12px;
    border: 1px solid ${(props) => props.theme.blue1};
    border-radius: 20px;
    width: 92%;
    cursor: pointer;
  }
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 65%;
  height: 70px;
  padding: 10px;
  border-top: 1px solid ${(props) => props.theme.black2};
  font-size: 16px;
  margin-top: 40px;
`;

export const JHCIcon = styled.div`
  width: 30%;
  height: 40px;
`;
